module.exports = __webpack_public_path__ + "static/bottom-segment@3x-b1fe5113b785eaf7411b66c460e4f5fc.png";